module.exports = __webpack_public_path__ + "img/pro_fourteen_6.2f0ae293.jpg";